
export default function GrayLine(){
      return<div className="h-c1 w-full bg-gray-300"></div>
}